




import Vue from "vue";
import Dashboard from "@/components/templates/Dashboard/index.vue";
import snackbar from "@/shared/snackbar";

export default Vue.extend({
  components: { Dashboard },
  async mounted() {
    try {
      this.$store.dispatch("app/getInformation");
    } catch (error) {
      snackbar.error(this, { message: error });
    }
  },
});
